import Swiper from "swiper/bundle";
import "./_partners.scss";

document.addEventListener("DOMContentLoaded", () => {
  const sliderPartners = document.querySelectorAll(".slider-partners");

  sliderPartners.forEach((slider) => {
    new Swiper(slider, {
      loop: true,
      spaceBetween: 0,
      slidesPerView: 1,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
        1400: {
          slidesPerView: 6,
          spaceBetween: 24,
        },
      },
    });
  });
});
